/**
 * Haptic Feedback Utility
 * Uses the Vibration API on supported mobile devices.
 * Falls back silently on desktop or unsupported browsers.
 */

type HapticPattern = 'light' | 'medium' | 'heavy' | 'success' | 'error' | 'warning';

const PATTERNS: Record<HapticPattern, number | number[]> = {
  light: 10,
  medium: 20,
  heavy: 40,
  success: [10, 50, 10],
  error: [30, 50, 30, 50, 30],
  warning: [20, 40, 20],
};

/**
 * Trigger haptic feedback on mobile devices.
 * No-op on desktop or unsupported browsers.
 */
export function haptic(pattern: HapticPattern = 'light') {
  if (typeof navigator === 'undefined' || !navigator.vibrate) return;
  // Only vibrate on mobile (< 768px)
  if (window.innerWidth >= 768) return;
  try {
    navigator.vibrate(PATTERNS[pattern]);
  } catch {
    // Silently fail
  }
}

/**
 * Trigger haptic on button click — use as onClick wrapper.
 * Example: onClick={() => { hapticClick(); doSomething(); }}
 */
export function hapticClick() {
  haptic('light');
}

/**
 * Trigger haptic for important actions (save, delete, etc.)
 */
export function hapticAction() {
  haptic('medium');
}

/**
 * Trigger haptic for success feedback
 */
export function hapticSuccess() {
  haptic('success');
}

/**
 * Trigger haptic for error feedback
 */
export function hapticError() {
  haptic('error');
}
